import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UserSubsidiaryReadOnlyRow = ({ key, t, userSubsidiaryItem, handleDeleteClick, oddIdx, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [dates, setDates ] = useState({startDate:userSubsidiaryItem.startDate, endDate:userSubsidiaryItem.endDate});
	
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userSubsidiaryItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userSubsidiaryItem, submitComplete);
	}

	const validateFields = () => {
		const errors = [];
		let date1;
		let date2;
		if(!dates.startDate){
			errors.push(t("error.startdateReqd"));
		}
		if(dates.endDate){
			if(dates.startDate instanceof Object){
				date1 = dates.startDate.getTime();
			} else {
				date1 = new Date(dates.startDate).getTime();
			}
			if(dates.endDate instanceof Object){
				date2 = dates.endDate.getTime();
			} else {
				date2 = new Date(dates.endDate).getTime();
			}
			if (date1 > date2) {
		    	errors.push(t("error.endDateBeforeStartDate"));
		  	} 
		}
		return errors;
	};
	function handleEditClick(event) {
		setIsSubmit(false);
		setIsEditMode(true);
	}

	function submitUpdate(event, userSubsidiaryItem) {
		event.preventDefault();
		setIsSubmit(true);
		let errors = validateFields();
		let startDateValue = dates.startDate;
		let endDateValue = dates.endDate;
		let dateObj;
		if(dates.startDate instanceof Object){
			dateObj = dates.startDate;
		} else {
			dateObj = new Date(dates.startDate);
		}
		startDateValue = [
						  	dateObj.getFullYear(),
						  	('0' + (dateObj.getMonth() + 1)).slice(-2),
						  	('0' + dateObj.getDate()).slice(-2)
						].join('-');

		if(dates.endDate){
			if( dates.endDate instanceof Object){
				dateObj = dates.endDate;
			} else {
				dateObj = new Date(dates.endDate);
			}
			endDateValue = [
							 	dateObj.getFullYear(),
		  						('0' + (dateObj.getMonth() + 1)).slice(-2),
			  					('0' + dateObj.getDate()).slice(-2)
							].join('-');
		}
		if(errors.length > 0){
			let errorText = "";
			setIsSubmit(false);
			for(let i=0; i < errors.length; i++){
				if(i > 0){
					errorText += "<br />";
				}
				errorText += errors[i];
			}
			setError(errorText);
			setIsEditMode(false);
		} else {
			let updatedValues = {
				loginId: userSubsidiaryItem.loginId,
				subsidiaryCompanyId: userSubsidiaryItem.companyId,
				startDate: startDateValue,
				endDate: endDateValue,
			};
			handleSubmit(2, updatedValues, submitUpdateComplete);
		}
		
	}
	function submitUpdateComplete() {
		setIsSubmit(false);
		setIsEditMode(false);
	}
	function submitCancel(event, userSubsidiaryItem) {
		setError("");
		setDates({startDate:userSubsidiaryItem.startDate, endDate:userSubsidiaryItem.endDate});
		setIsEditMode(false);
		setIsSubmit(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userSubsidiaryItem.companyName}</td>
			{isEditMode ? (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
					 	<DatePicker dateFormat="MM-dd-yyyy" id="startDate" selected={dates.startDate? new Date(dates.startDate) : ""} onChange={(date) => setDates({startDate : date, endDate: dates.endDate})} />
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<DatePicker dateFormat="MM-dd-yyyy" id="endDate" selected={dates.endDate? new Date(dates.endDate) : ""} onChange={(date) => setDates({startDate: dates.startDate, endDate : date})} />
					</td> 
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
				</>


			) : (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+userSubsidiaryItem.startDate}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+userSubsidiaryItem.endDate}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userSubsidiaryItem.status}</td>
				</>
			)}

			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEditMode ? (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => submitUpdate(event, userSubsidiaryItem)}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
							onClick={(event) => (submitCancel(event, userSubsidiaryItem))}>{t("page.cancel")}</button>
					</>
				) : (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, userSubsidiaryItem)}>
							{userSubsidiaryItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
					</>
				)}

			</td>
		</tr>
	)
}
export default UserSubsidiaryReadOnlyRow;